const TermsandCondition = () => {
  return (
    <div>
      <h1>Terms and Conditions</h1>
      <p>Terms and Conditions</p>
    </div>
  );
};
export default TermsandCondition;
